import {connect} from "react-redux";
import DashboardComponent from "../../components/DashboardComponent";


const stateToProps = (state) => {
    return {
    costUploadPhotos: state.cost.uploads.photos,
    costPhotoProcess: state.cost.uploads.show,
    permission:state.login.employeeInfo.permission,
    isManager:state.login.employeeInfo.isManager,
    accessToken: state.login.employeeInfo.accessToken,
    language : state.login.employeeInfo.language
  }
};
const dispatchToProps = (dispatch) => {
  return {
    dispatch:dispatch
  }
};

const Dashboard = connect(stateToProps,dispatchToProps)(DashboardComponent);
export default Dashboard;
